import { createRoot } from 'react-dom/client';
import HistoryResult from '@/pages/AfterMeet/Result';
import { HistoryItem } from '@/utils/store/store';

interface ResultModalOptions {
  /** 自动导出图片模式：弹窗打开后自动截图导出，完成后自动关闭 */
  autoExportImage?: boolean;
}

/**
 * 历史记录结果弹窗
 * 命令式调用，使用自定义 Notion 风格弹窗替代 Ant Design Modal
 */
export const ResultModal = (item: HistoryItem, options?: ResultModalOptions) => {
  const container = document.createElement('div');
  document.body.appendChild(container);
  const root = createRoot(container);

  const handleClose = () => {
    root.unmount();
    container.remove();
  };

  root.render(
    <HistoryResult
      historyItem={item}
      onClose={handleClose}
      autoExportImage={options?.autoExportImage}
    />
  );
};
